// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_math from "rescript/lib/es6/js_math.js";

import '../../input.css'
;

var myFacts = [
  {
    id: "fact1",
    question: "My nickname is",
    answer: "Tata"
  },
  {
    id: "fact2",
    question: "My hometown is",
    answer: "Hat Yai, Songkhla, Thailand"
  },
  {
    id: "fact3",
    question: "My favourite food is",
    answer: "Papaya salad (Som tum)"
  },
  {
    id: "fact4",
    question: "My favourite song is",
    answer: "Get Lucky"
  },
  {
    id: "fact5",
    question: "My favourite serie is",
    answer: "Hometown Cha-Cha-Cha"
  },
  {
    id: "fact6",
    question: "My favourite book is",
    answer: "Atomic Habits"
  },
  {
    id: "fact7",
    question: "My favourite sport is",
    answer: "Football"
  },
  {
    id: "fact8",
    question: "My favourite football team is",
    answer: "Manchester United"
  },
  {
    id: "fact9",
    question: "My favourite footballer is",
    answer: "Cristiano Ronaldo"
  }
];

function Fact(Props) {
  var componentToHex = function (c) {
    var hex = c.toString(16);
    if (hex.length === 1) {
      return "0" + hex;
    } else {
      return hex;
    }
  };
  var generateRandomColor = function (mix) {
    var red = Js_math.random_int(0, 256);
    var green = Js_math.random_int(0, 256);
    var blue = Js_math.random_int(0, 256);
    red = (red + mix.r | 0) / 2 | 0;
    green = (green + mix.g | 0) / 2 | 0;
    blue = (blue + mix.b | 0) / 2 | 0;
    return "#" + componentToHex(red) + componentToHex(green) + componentToHex(blue);
  };
  var items = myFacts.map(function (fact, index) {
        var randomHex = generateRandomColor({
              r: 255,
              g: 255,
              b: 255
            });
        return React.createElement("div", {
                    key: fact.id,
                    className: "transition mx-5 my-2 p-2 rounded-lg min-w-[300px] drop-shadow-lg hover:drop-shadow-2xl hover:scale-110",
                    style: {
                      backgroundColor: "" + randomHex + ""
                    }
                  }, React.createElement("p", undefined, React.createElement("strong", undefined, "Question " + String(index + 1 | 0) + ": "), fact.question), React.createElement("p", undefined, "Answer: " + fact.answer));
      });
  return React.createElement("section", {
              className: "max-w-[1100px] mx-auto"
            }, React.createElement("h2", {
                  className: "text-center text-xl font-bold mt-10 mb-2"
                }, "9 Facts About Me"), React.createElement("div", {
                  className: "flex flex-wrap justify-center"
                }, items));
}

var make = Fact;

export {
  myFacts ,
  make ,
}
/*  Not a pure module */
